import React, { Component } from "react";

export default class DispatcherDashboard extends Component {
  render() {
    return <div>Comming Soon</div>;
  }
}



// WEBPACK FOOTER //
// ./src/customers/dispatchers/dashboard.js